<template>
    <slot />
</template>

<script>
export default {
    name: 'auth-layout',
};
</script>
